// @flow
import React, { PureComponent } from "react"
import { connect } from "react-redux"
import classNames from "classnames"
import type { Connector } from "react-redux"
import type { Node } from "react"

import translate from "../../../../app/scripts/tools/translate"
import Translate from "../../../../app/scripts/components/Translate"
import { handleBlockScrollBody } from "common/utils/scrollUtils"
import CloseByKey from "../CloseByKey/CloseByKey"
import { isMobileSelector } from "../../services/window"

type OwnProps = {
  onClose: () => void,
  onKeyDown: KeyboardEvent => void,
  children: Node,
  wide?: boolean,
  closable?: boolean,
  closeOnOverlayClick?: boolean,
  passedClasses?: ?string,
  modalID?: string,
}

type Props = OwnProps & {
  isMobile: boolean,
  isWebview: boolean,
}

class ModalBody extends PureComponent<Props> {
  static defaultProps = {
    wide: false,
    closable: true,
    passedClasses: null,
    closeOnOverlayClick: false,
    modalID: "modal-0-id-0",
  }

  componentDidMount() {
    this.setScrollable(true)
  }

  componentWillUnmount() {
    this.setScrollable(false)
  }

  setScrollable = (value: boolean) => {
    if (this.props.isMobile) {
      handleBlockScrollBody(value)
    } else {
      const viewEl = document.getElementById("react-view")

      if (viewEl) {
        if (value) {
          viewEl.setAttribute("inert", "true")
        } else {
          viewEl.removeAttribute("inert")
        }
      }
    }
  }

  handleOverlayClose = () => {
    if (this.props.closeOnOverlayClick) {
      this.props.onClose()
    }
  }

  render() {
    const {
      onClose,
      onKeyDown,
      children,
      wide,
      closable,
      passedClasses = "",
      modalID,
      isMobile,
      isWebview,
    } = this.props

    return (
      <CloseByKey onClose={onClose}>
        <div
          className={classNames("Modal", passedClasses)}
          data-test="Modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby={modalID}
        >
          <div onClick={this.handleOverlayClose} className="Modal-content-wrap">
            {closable && isMobile && !isWebview && (
              <div onClick={e => e.stopPropagation()} className="Modal-header spShadow">
                <span
                  onClick={onClose}
                  onKeyDown={onKeyDown}
                  role="button"
                  tabIndex="0"
                  className="Modal-header-close"
                >
                  <Translate tKey="common.close" />
                </span>
              </div>
            )}

            <div
              onClick={e => e.stopPropagation()}
              className={classNames("Modal-content", {
                wide,
              })}
            >
              {closable && !isMobile && !isWebview && (
                <span
                  onClick={onClose}
                  onKeyDown={onKeyDown}
                  className="Modal-close"
                  data-test="Modal-close"
                  role="button"
                  aria-label={translate("common.close")}
                  tabIndex="0"
                />
              )}
              {children}
            </div>
          </div>
        </div>
      </CloseByKey>
    )
  }
}

const connector: Connector<OwnProps, Props> = connect(state => ({
  isMobile: isMobileSelector(state),
  isWebview: state.options.ui === "webview",
}))

export default connector(ModalBody)
